// `Object.keys` всегда возвращает `string[]`, а `getObjectKeys` - типизированный массив с ключами объекта
export function getObjectKeys<T extends object>(object: T): (keyof T)[] {
  return Object.keys(object) as (keyof T)[]
}
